import {
  AttachmentVisibilityContactModified,
  SocketData,
} from 'actions/socket/socketReceiveDataAction'

import { ChatMessengerState } from '../ChatMessengerState'

export const updateAttachmentVisibilityContactModified = (
  socketData: SocketData<AttachmentVisibilityContactModified>,
  chatState: ChatMessengerState
) => {
  const { contactId, status } = socketData.content

  if (chatState.chatData.contactId !== contactId) {
    return chatState
  }

  return {
    ...chatState,
    photosRestrictionStatus: {
      ...chatState.photosRestrictionStatus,
      status,
      noRestrictionForMessagesWithIds: [],
    },
  }
}
